import type { FaireProductEntity } from "../../entity_types/product";

export const p_xhmw7aar3c: FaireProductEntity = {
  token: "p_xhmw7aar3c",
  type: "product",
  name: "Flower Look Coupe-6\"H(6oz)",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/8e1db309e3385a15865e5aeff190ad6568144a600f0b2ffdf29ccc898776690f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee020698e0fcbe00af084dbe5f31588bc805479bf40e1a2b445a716d28e831d3.jpeg",
    "https://cdn.faire.com/fastly/67a5323762add6253fb9951c3bed4eb5ffb1ebdc22e9cc64a014fdda20166f33.jpeg",
    "https://cdn.faire.com/fastly/d06926784ef8e02b4627369bd73004256ec3e3a681e4263c62129d28bd61bf33.jpeg",
    "https://cdn.faire.com/fastly/d053c75d393e56f2c0e29d94aeca4a1c87611afde588aba40d766546ce8369ad.jpeg",
    "https://cdn.faire.com/fastly/e4d37c1c7bf6fc1e34cd8a941b6594bb2ea1d2d4ea402e0442d0d80f1c11e3dc.jpeg"
  ],
  priceDollars: 10,
  description: "Our Flower Look Coupe Glass adds a delightful, feminine touch to your celebrations. Crafted in delicate pink, with a green base will impress your guests and elevate the ambience of any occasion. Also available in a flute or wine glass.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:05.960Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
